import { useState } from 'react';
import { Bouton } from '../composants/base.jsx';

export function EcranConnexion({ onConnecte }) {
  const [utilisateur, setUtilisateur] = useState('test');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState(null);
  const [occupe, setOccupe] = useState(false);

  async function envoyer(e) {
    e.preventDefault();
    if (occupe) return;
    setOccupe(true);
    setErreur(null);
    try {
      const r = await fetch('/api/connexion', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ utilisateur, motDePasse }),
      });
      const j = await r.json().catch(() => ({}));
      if (r.ok) { onConnecte(); return; }
      setErreur(j.erreur ?? 'Connexion refusée.');
    } catch {
      // Sans réseau on ne peut pas ouvrir de session : le dire franchement plutôt que
      // de laisser tourner un rond. L'application installée, elle, reste utilisable —
      // la session vaut six mois précisément pour ça.
      setErreur('Pas de réseau. La connexion a besoin du serveur, une seule fois.');
    } finally {
      setOccupe(false);
    }
  }

  return (
    <form
      onSubmit={envoyer}
      style={{
        flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center',
        gap: 14, padding: '0 26px',
        paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <img src="/icones/aja.svg" alt="" width="76" height="76" style={{ borderRadius: 20, marginBottom: 6 }} />
      <div>
        <h1 style={{ margin: 0, fontSize: 30, fontWeight: 800, letterSpacing: '-.7px' }}>Compo AJA</h1>
        <p style={{ margin: '7px 0 0', fontSize: 13.5, lineHeight: 1.5, color: 'var(--ink2)' }}>
          Une seule connexion, puis l&apos;application marche sans réseau.
        </p>
      </div>

      <Champ label="Identifiant" value={utilisateur} onChange={setUtilisateur} autoComplete="username" />
      <Champ label="Mot de passe" value={motDePasse} onChange={setMotDePasse} type="password" autoComplete="current-password" />

      {erreur && (
        <div role="alert" style={{ padding: '11px 13px', borderRadius: 12, background: 'color-mix(in oklch, var(--bad) 16%, transparent)', color: 'var(--bad)', fontSize: 12.5, lineHeight: 1.45 }}>
          {erreur}
        </div>
      )}

      <Bouton ton="principal" large taille={54} type="submit" disabled={occupe || !motDePasse} style={{ marginTop: 4, opacity: occupe || !motDePasse ? .5 : 1 }}>
        {occupe ? 'Connexion…' : 'Entrer'}
      </Bouton>
    </form>
  );
}

function Champ({ label, value, onChange, ...reste }) {
  return (
    <label style={{ display: 'block' }}>
      <span style={{ display: 'block', fontSize: 10, fontWeight: 700, letterSpacing: '.8px', color: 'var(--ink2)', marginBottom: 6 }}>{label.toUpperCase()}</span>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        // 16 px : en dessous, Safari zoome à la mise au point du champ et ne dézoome
        // jamais — l'écran reste agrandi pour le reste de la session.
        style={{ width: '100%', height: 52, borderRadius: 14, padding: '0 15px', fontSize: 16, background: 'var(--surf)', border: '1px solid var(--line)', outline: 'none' }}
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck="false"
        {...reste}
      />
    </label>
  );
}
